// Buy Box der Produktseite (sections/main-product.liquid, .wt-product__main) auf dem Desktop in beide Richtungen sticky.
// Nur aktiv, wenn die Box hoeher als das Fenster ist. Drei Modi, gewechselt nur an Richtungswechseln und Grenzen,
// dazwischen scrollt der Browser selbst (kein Setzen pro Frame, dadurch kein Ruckeln):
//   top    klebt oben (Abstand GAP)
//   free   laeuft mit der Seite, per margin-top an der aktuellen Stelle gehalten
//   bottom klebt unten (Ende der Box GAP ueber dem Fensterrand)
(() => {
  const GAP = 24;
  const mq = window.matchMedia('(min-width: 900px)');

  function init(main) {
    const box = main.parentElement;
    let mode = 'off';
    let lastY = window.scrollY;

    const set = (next, pos, top, mt) => {
      mode = next;
      main.style.setProperty('--su-pos', pos);
      main.style.setProperty('--su-top', top + 'px');
      main.style.setProperty('--su-mt', Math.max(0, mt) + 'px');
    };
    const freeHere = () => {
      // Aktuelle Lage relativ zum Container uebernehmen, begrenzt auf den Platz neben der Galerie
      const offset = main.getBoundingClientRect().top - box.getBoundingClientRect().top;
      const room = box.offsetHeight - main.offsetHeight - (parseFloat(getComputedStyle(main).marginBottom) || 0);
      set('free', 'relative', 0, Math.min(Math.max(0, room), offset));
    };

    function update() {
      const y = window.scrollY;
      const dir = y > lastY ? 1 : y < lastY ? -1 : 0;
      lastY = y;
      const vh = window.innerHeight;
      const tall = mq.matches && main.offsetHeight > vh - 2 * GAP;
      if (!tall) {
        if (mode !== 'off') { main.classList.remove('su-sticky'); mode = 'off'; }
        return;
      }
      if (mode === 'off') { main.classList.add('su-sticky'); set('top', 'sticky', GAP, 0); }
      const top = main.getBoundingClientRect().top;
      const bottomTop = vh - main.offsetHeight - GAP;
      if (dir > 0) {
        if (mode === 'top') freeHere();
        else if (mode === 'free' && top <= bottomTop) set('bottom', 'sticky', bottomTop, 0);
      } else if (dir < 0) {
        if (mode === 'bottom') freeHere();
        else if (mode === 'free' && top >= GAP) set('top', 'sticky', GAP, 0);
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', () => { if (mode === 'bottom') set('bottom', 'sticky', window.innerHeight - main.offsetHeight - GAP, 0); update(); });
    // Akkordeon auf oder zu: an der aktuellen Stelle loslassen, damit die Box nach unten waechst statt zu springen
    new ResizeObserver(() => {
      if (mode === 'top' || mode === 'bottom') freeHere();
      update();
    }).observe(main);
    update();
  }

  const start = () => document.querySelectorAll('.product-section .wt-product__main').forEach((main) => {
    if (main.dataset.suSticky) return;
    main.dataset.suSticky = '1';
    init(main);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
